var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOtherHeading = function SvgOtherHeading(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9861 13.8744H40.7339V14.9972H39.7427V13.8744H38.6069V14.9972H37.9329V38.4527H38.2908C38.4135 38.4529 38.5131 38.5477 38.5133 38.665V43.6439H38.8489V40.5203H41.6972V34.8238H47.3919V65.2052H46.2144V66.4198C46.1994 66.4533 44.9811 69.1262 36.3901 69.1262C36.3507 69.1262 36.3114 69.1245 36.2723 69.1244C36.2332 69.1245 36.194 69.1262 36.1546 69.1262C27.5636 69.1262 26.3452 66.4533 26.3303 66.4198V65.2052H24.6132V47.1662H24.6113V46.2168H24.6132V45.2674H24.6113V44.318H24.6132V43.3686H24.6113V42.4191H24.6132V41.4697H24.6113V40.5203H24.6132V34.8238H30.3079V44.0908H31.4186V43.6439H32.776V38.665C32.7761 38.5476 32.8764 38.4527 32.9994 38.4527H33.6716V14.9972H33.3657V13.8744H32.2299V14.9972H31.2387V13.8744H31.0681V2.87354H40.9861V13.8744Z",
    stroke: "#BDBDBD",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0147 43.8682H40.6074V55.897H32.0147V43.8682Z",
    fill: "#C68106"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.416 43.27V56.4952H41.2051V43.27H31.416ZM40.009 55.2991H32.6121V44.4661H40.009V55.2991Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 34.4502H30.3066V64.8317H24.6117V34.4502Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 34.4502H47.3906V64.8317H41.6957V34.4502Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 34.4502H47.3906V35.3996H41.6957V34.4502Z",
    fill: "#414141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 34.4502H30.3066V35.3996H24.6117V34.4502Z",
    fill: "#414141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 49.6411H47.3906V50.5905H41.6957V49.6411Z",
    fill: "#414141"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 49.6411H30.3066V50.5905H24.6117V49.6411Z",
    fill: "#414141"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 53.4385H30.3066V54.3879H24.6117V53.4385Z",
    fill: "#414141"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 57.2363H30.3066V58.1857H24.6117V57.2363Z",
    fill: "#414141"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 61.0342H30.3066V61.9836H24.6117V61.0342Z",
    fill: "#414141"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 51.54H47.3906V52.4895H41.6957V51.54Z",
    fill: "#414141"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 51.54H30.3066V52.4895H24.6117V51.54Z",
    fill: "#414141"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 55.3374H30.3066V56.2868H24.6117V55.3374Z",
    fill: "#414141"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 59.1353H30.3066V60.0847H24.6117V59.1353Z",
    fill: "#414141"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 62.9331H30.3066V63.8825H24.6117V62.9331Z",
    fill: "#414141"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 53.4385H47.3906V54.3879H45.4918V53.4385Z",
    fill: "#414141"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 53.4385H30.3066V54.3879H28.4078V53.4385Z",
    fill: "#414141"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 55.3374H47.3906V56.2868H45.4918V55.3374Z",
    fill: "#414141"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 55.3374H30.3066V56.2868H28.4078V55.3374Z",
    fill: "#414141"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 57.2363H47.3906V58.1857H45.4918V57.2363Z",
    fill: "#414141"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 57.2363H30.3066V58.1857H28.4078V57.2363Z",
    fill: "#414141"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 59.1353H47.3906V60.0847H45.4918V59.1353Z",
    fill: "#414141"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 59.1353H30.3066V60.0847H28.4078V59.1353Z",
    fill: "#414141"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 61.0342H47.3906V61.9836H45.4918V61.0342Z",
    fill: "#414141"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 61.0342H30.3066V61.9836H28.4078V61.0342Z",
    fill: "#414141"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 62.9331H47.3906V63.8825H45.4918V62.9331Z",
    fill: "#414141"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 62.9331H30.3066V63.8825H28.4078V62.9331Z",
    fill: "#414141"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 42.0454H47.3906V42.9948H45.4918V42.0454Z",
    fill: "#414141"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.609 42.0454H26.5078V42.9948H24.609V42.0454Z",
    fill: "#414141"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.609 43.9443H26.5078V44.8938H24.609V43.9443Z",
    fill: "#414141"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.609 45.8433H26.5078V46.7927H24.609V45.8433Z",
    fill: "#414141"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 43.9443H47.3906V44.8938H45.4918V43.9443Z",
    fill: "#414141"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 43.9443H30.3066V44.8938H28.4078V43.9443Z",
    fill: "#414141"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 45.8433H47.3906V46.7927H45.4918V45.8433Z",
    fill: "#414141"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 45.8433H30.3066V46.7927H28.4078V45.8433Z",
    fill: "#414141"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 47.7422H47.3906V48.6916H41.6957V47.7422Z",
    fill: "#414141"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 47.7422H30.3066V48.6916H24.6117V47.7422Z",
    fill: "#414141"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 38.248H47.3906V39.1975H41.6957V38.248Z",
    fill: "#414141"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 38.248H30.3066V39.1975H24.6117V38.248Z",
    fill: "#414141"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4918 40.147H47.3906V41.0964H45.4918V40.147Z",
    fill: "#414141"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.609 40.147H26.5078V41.0964H24.609V40.147Z",
    fill: "#414141"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 36.3491H47.3906V37.2985H41.6957V36.3491Z",
    fill: "#414141"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6117 36.3491H30.3066V37.2985H24.6117V36.3491Z",
    fill: "#414141"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2667 43.2664V13.626H37.3318V43.2664L38.3535 47.9276V49.7319H33.0878V48.0027L34.2667 43.2664Z",
    fill: "#F9BA15"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6701 13.0278V43.1923L32.5093 47.8579L32.4917 47.9292V50.3297H38.9531V47.8625L38.9392 47.7994L37.9314 43.2016V13.0278H33.6701ZM36.7353 43.3314L36.7492 43.3945L37.7571 47.9914V49.1336H33.6877V48.0757L34.8485 43.4112L34.8662 43.3398V14.2239H36.7353V43.3314Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8229 49.5547C36.978 49.9998 37.2199 50.752 37.2846 51.5389C37.3499 52.3329 37.2295 53.0878 36.7441 53.6139L37.2939 54.121C37.9877 53.3691 38.1023 52.3564 38.0301 51.4777C37.9572 50.5919 37.6887 49.7652 37.5294 49.3081L36.8229 49.5547Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3348 49.3081C34.1754 49.7652 33.906 50.5919 33.8332 51.4777C33.7609 52.3564 33.8764 53.3691 34.5703 54.121L34.8447 53.867L35.1191 53.6139C34.6338 53.0878 34.5133 52.3329 34.5786 51.5389C34.6433 50.7521 34.8852 49.9998 35.0403 49.5547L34.3348 49.3081Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7739 45.0829C32.7739 45.2005 32.8737 45.2959 32.9969 45.2959H33.7303C33.8533 45.2959 33.9531 45.2005 33.9531 45.0829V38.2917C33.9531 38.1741 33.8533 38.0786 33.7303 38.0786H32.9969C32.8737 38.0786 32.7739 38.1741 32.7739 38.2917V45.0829Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3325 45.0829C37.3325 45.2005 37.4323 45.2959 37.5555 45.2959H38.2889C38.4119 45.2959 38.5117 45.2005 38.5117 45.0829V38.2917C38.5117 38.1741 38.4119 38.0786 38.2889 38.0786H37.5555C37.4323 38.0786 37.3325 38.1741 37.3325 38.2917V45.0829Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0957 53.3764V60.5595H26.5117V43.8472H32.7001V53.1901L46.0957 53.3764Z",
    fill: "#F9BA15"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1343 53.19H32.7736V43.7173H26.329V66.0459C26.329 66.0459 27.5078 68.7523 36.153 68.7523C44.7982 68.7523 46.2129 66.0459 46.2129 66.0459L46.1343 53.19Z",
    fill: "#F9BA15"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4067 53.19H39.7675V43.7173H46.2121V66.0459C46.2121 66.0459 45.0332 68.7523 36.388 68.7523C27.7428 68.7523 26.3281 66.0459 26.3281 66.0459L26.4067 53.19Z",
    fill: "#F9BA15"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0252 53.9377H45.3903L45.4636 65.8008C45.4319 65.8362 45.3915 65.8782 45.3412 65.926C45.1353 66.1211 44.7558 66.4164 44.1053 66.7234C42.8 67.3391 40.4021 68.0047 36.152 68.0047C31.8999 68.0047 29.5671 67.3377 28.3276 66.728C27.711 66.4246 27.3653 66.136 27.1844 65.9492C27.139 65.9023 27.1031 65.8615 27.0759 65.8277V44.4648H32.0252V53.9377ZM26.3277 66.0465L25.6435 66.3469L25.6444 66.3488C25.6449 66.3499 25.6448 66.3513 25.6453 66.3525C25.6465 66.3552 25.6486 66.3578 25.65 66.3608C25.6528 66.3669 25.6557 66.3739 25.6592 66.3812C25.6664 66.396 25.6755 66.4136 25.6861 66.4331C25.7073 66.4722 25.7354 66.5203 25.7724 66.5759C25.8466 66.6878 25.9551 66.8296 26.1098 66.9895C26.4202 67.31 26.9094 67.6976 27.6675 68.0705C29.1788 68.814 31.7589 69.5002 36.152 69.5002C40.547 69.5002 43.1798 68.8127 44.7431 68.0752C45.5265 67.7056 46.0409 67.3239 46.3703 67.0117C46.5347 66.8559 46.6513 66.7185 46.7319 66.6112C46.7721 66.5577 46.8032 66.5118 46.8265 66.4749C46.8381 66.4564 46.8483 66.4395 46.8562 66.4257C46.86 66.419 46.8633 66.4127 46.8664 66.4072C46.8678 66.4045 46.8697 66.4022 46.871 66.3998L46.8738 66.3942C46.8742 66.3934 46.873 66.3921 46.2118 66.0465L46.8747 66.3924L46.9609 66.2273L46.9591 66.0419L46.8766 52.4422H33.5198V42.9702H25.5804V66.2023L25.6425 66.3451L26.3277 66.0465Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4864 49.4438C26.4864 49.5614 26.5862 49.6569 26.7093 49.6569H32.1581C32.281 49.6569 32.3809 49.5614 32.3809 49.4438V48.1408C32.3809 48.0232 32.281 47.9277 32.1581 47.9277H26.7093C26.5862 47.9277 26.4864 48.0232 26.4864 48.1408V49.4438Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 53.5787C26.8008 53.6963 26.9006 53.7918 27.0237 53.7918H32.1581C32.281 53.7918 32.3809 53.6963 32.3809 53.5787V53.1027C32.3809 52.9851 32.281 52.8896 32.1581 52.8896H27.0237C26.9006 52.8896 26.8008 52.9851 26.8008 53.1027V53.5787Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5642 64.0938V64.841H45.8984V64.0938H26.5642Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8481 40.147H46.4414V53.4389H38.8481V40.147Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7972 43.4697H45.4922V49.008H39.7972V43.4697Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7972 41.2544H45.4922V42.3621H39.7972V41.2544Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.229 9.83398H31.2383V14.6234H32.229V9.83398Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.356 9.83398H33.3652V14.6234H34.356V9.83398Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M38.606 9.83398H37.6152V14.6234H38.606V9.83398Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.733 9.83398H39.7422V14.6234H40.733V9.83398Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2359 3.24805H31.8145V12.752H40.2359V3.24805Z",
    fill: "#F9BA15"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9863 2.5V13.5009H31.0684V2.5H40.9863ZM32.5648 12.0035H39.4898V3.99645H32.5648V12.0035Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7693 3.77197H35.2832V5.71765H36.7693V3.77197Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0989 17.9907H34.7871V29.8893H37.0989V17.9907Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5576 8.0249H32.4863V12.1306H39.5576V8.0249Z",
    fill: "#C68106"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0729 7.6377V8.38685H32.1465V7.6377H40.0729Z",
    fill: "#231F20"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6756 5.86768H34.373V10.9564H37.6756V5.86768Z",
    fill: "#F9BA15"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0517 5.49268V11.3301H34V5.49268H38.0517ZM34.7492 10.5819H37.3026V6.24183H34.7492V10.5819Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2757 10.582H35.6152V17.8409H36.2757V10.582Z",
    fill: "#BDBDBD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOtherHeading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "other-heading.121c89fd77b1b22b3addd52c4c9fc3bb.svg";